import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ProductSizeGuideComponent } from '../product-size-guide.component';
import { NProductSizeGuideModal } from './product-size-guide-modal.interface';

@DfModal({
    id: NProductSizeGuideModal.ID,
    position: 'right',
    config: () => {
        return {
            minWidth: undefined,
            maxWidth: undefined,
            height: '100%',
            width: '100%',
            position: {
                right: '0',
                bottom: '0',
                left: '0'
            },
            modalClass: 'bg-col-w p-l p-r p-b-0'
        };
    },
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@Component({
    selector: 'product-size-guide-modal',
    templateUrl: './product-size-guide-modal.component.html',
    standalone: true,
    imports: [CommonModule, ProductSizeGuideComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSizeGuideModalComponent {
    protected modalRef = inject(ModalRef);
    protected modalData = inject(MODAL_DATA);

    closeModal(): void {
        this.modalRef?.close();
    }
}
